import React, { useEffect, useState } from "react";
import { FiX } from "react-icons/fi";
import { IoMdNotifications } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteAllNotifications,
  deleteNotification,
  getNotification,
  selectNotifications,
} from "../../redux/features/notification/NotificationSlice";

import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { selectUser } from "../../redux/features/auth/AuthSlice";

dayjs.extend(relativeTime);

const Notification = () => {

   const user = useSelector(selectUser);
  const [isOpen, setIsOpen] = useState(false);
  const dispatch = useDispatch();
  const notification = useSelector(selectNotifications);

  const displayedNotifications =
  user?.role === "counter"
    ? notification?.slice(0, 30) // latest 30
    : notification;
  // console.log(notification);
  useEffect(() => {
    dispatch(getNotification());
    const intervalId = setInterval(() => {
      dispatch(getNotification());
    }, 10000);
    return () => clearInterval(intervalId);
  }, [dispatch]);

  const delNotification = async (id) => {
    if (!id) {
      return;
    }
    await dispatch(deleteNotification(id));
    dispatch(getNotification());
  };

  const deleteAllNotification = async () => {
    await dispatch(deleteAllNotifications());
    dispatch(getNotification());
  };

  useEffect(() => {
    const handler = (event) => {
      if (!event.target.closest(".notification") && isOpen) setIsOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [isOpen]);

  return (
    <div className=" relative notification ">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="bg-[#A9A9A9] cursor-pointer outline-none text-white px-3 md:py-2 py-[6.5px]  md:rounded-xl rounded-lg"
      >
        <IoMdNotifications className="size-5" />
      </button>
      {displayedNotifications?.length > 0 && (
        <div className=" absolute top-[-4px] right-[-4px] text-[.7rem] text-[#1a1919] font-semibold bg-white py-1 px-1.5 leading-none rounded-full">
          {displayedNotifications.length}
        </div>
      )}
      {isOpen && (
        <div className=" absolute z-50 top-10 right-0 max-h-[20rem] min-h-[7rem]   rounded-lg p-2 bg-white md:w-[15rem] w-[12rem] ">
          <div className="flex justify-between items-center text-[.8rem] border-b border-[#03311f]">
            <span className="">Order Notification</span>
            <span className=" cursor-pointer">
              <FiX onClick={() => setIsOpen(false)} className="size-4 " />
            </span>
          </div>
          {displayedNotifications?.length > 0 ? (
            <div className="flex flex-col gap-1 my-2 overflow-y-auto max-h-[15rem]">
              {displayedNotifications?.map((notifi, i) => (
                <div
                  key={i}
                  className="flex flex-col text-[.6rem] border-[.2px] rounded-md border-[#03311f] p-1"
                >
                  <div className="flex justify-between items-center">
                    <span className=" capitalize">{notifi?.userName}</span>
                    <span> {dayjs(notifi?.createdAt).fromNow()}</span>
                    <span
                      onClick={() => delNotification(notifi._id)}
                      className=" cursor-pointer"
                    >
                      <FiX className="size-3 " />
                    </span>
                  </div>
                  <span className=" capitalize">{notifi?.message}</span>
                </div>
              ))}
            </div>
          ) : (
            <span className="flex justify-center items-center h-full py-2 text-[#a9a9a9]">
              No new notifications
            </span>
          )}
          {displayedNotifications?.length > 0 && (
            <button
              onClick={() => deleteAllNotification()}
              className="text-[.7rem]  hover:text-[#0778e2] cursor-pointer outline-none "
            >
              Clear Notification
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default Notification;
